<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'ModuleAccountGeneral',
  computed: {
    ...mapState('administrator/me', [
      'item',
      'currentPassword',
    ]),
    first_name: {
      get () {
        return this.item.first_name;
      },
      set (value) {
        this.setFirst_name(value);
      },
    },
    last_name: {
      get () {
        return this.item.last_name;
      },
      set (value) {
        this.setLast_name(value);
      },
    },
    email: {
      get () {
        return this.item.email;
      },
      set (value) {
        this.setEmail(value);
      },
    },
    localCurrentPassword: {
      get() {
        return this.currentPassword;
      },
      set(value) {
        this.setCurrentPassword(value);
      },
    },
  },
  methods: {
    ...mapActions('administrator/me', [
      'save'
    ]),
    ...mapMutations('administrator/me', [
      'setFirst_name',
      'setLast_name',
      'setEmail',
      'setCurrentPassword'
    ]),
    localSave () {
      const payload = {
        email: this.item.email,
        first_name: this.item.first_name,
        last_name: this.item.last_name,
      };

      this.save(payload)
        .then(res => console.log(res))
      ;
    },
  },
};
</script>
<template>
  <div class="box-padding mt-2">
    <h2>General</h2>
    <div class="form-group mt-3">
      <label for="first_name" class="d-block">First Name</label>
      <input id="first_name" class="form-control rounded-0" v-model="first_name" />
    </div>
    <div class="form-group mt-3">
      <label for="last_name" class="d-block">Last Name</label>
      <input id="last_name" class="form-control rounded-0" v-model="last_name" />
    </div>
    <div class="form-group mt-3">
      <label for="email" class="d-block">Email</label>
      <input id="email" type="email" class="form-control rounded-0" v-model="email" />
    </div>
    <!-- <div class="form-group mt-5">
      <label for="current_password" class="d-block">Current Password</label>
      <input id="current_password" class="form-control rounded-0" v-model="localCurrentPassword" />
    </div> -->
    <div class="form-group mt-3 text-right">
      <button class="btn btn-primary" @click="localSave">Save</button>
    </div>
  </div>
</template>
